import axios, { AxiosInstance } from 'axios';
import { useGlobalStore } from '@/stores/global';
import { showToast } from '@/shares/feedback/showToast';
import { tracker } from '@/track';
// import { getDeviceId } from '@/utils/common'
// import { localGet } from '../storage'
// let DXTOKEN: string = ''
import { CurrencySymbol } from '@/types/types';
const HOST_API = process.env.NEXT_PUBLIC_HOST_API;
let toastLang = 'en';
const errorStatus = {
  416: {
    zh: '设备环境异常，无法进行操作',
    'zh-CN': '设备环境异常，无法进行操作',
    zh_tw: '設備環境異常，無法進行操作',
    'zh-TW': '設備環境異常，無法進行操作',
    en: 'The device environment is abnormal, and operations cannot be performed',
  },
  429: {
    zh: '当前参与人数过多,请您稍后片刻再进行尝试',
    'zh-CN': '当前参与人数过多,请您稍后片刻再进行尝试',
    'zh-TW': '目前參與人數過多,請您稍後再嘗試',
    en: 'Network congested, try again later',
  },
  503: {
    zh: '当前参与人数过多,请您稍后片刻再进行尝试',
    'zh-CN': '当前参与人数过多,请您稍后片刻再进行尝试',
    'zh-TW': '目前參與人數過多,請您稍後再嘗試',
    en: 'Network congested, try again later',
  },
};
export const request: AxiosInstance = axios.create({
  baseURL: HOST_API,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    token: '', //钱包id
    language: 'en', //语言
    currency: '', //货币单位
    apiBrand: 'web',
    os: '',
    package: '',
    im: '',
    timezonename: 0 - new Date().getTimezoneOffset() / 60, //时区
    markethour: 'hour',
  },
});
const EventData = {
  address: '',
  channel_af: '',
  system_language: 'en',
  wallet_tag: '',
  wallet_type: '',
};
request.interceptors.request.use(
  async config => {
    const store = useGlobalStore.getState();
    const { LANGUAGE } = store.bgwheadInfo;
    const reqLanguage = LANGUAGE == 'zh-CN' ? 'zh' : LANGUAGE == 'zh-TW' ? 'zh_tw' : LANGUAGE;
    EventData.channel_af = config.url || '';
    EventData.address = store.token;
    EventData.system_language = reqLanguage;
    // @ts-expect-error Headers assignment type mismatch
    config.headers = {
      ...config.headers,
      ...store.bgwheadInfo,
      ['seqnum_key']: new Date().getTime(),
      token: store.token ?? '',
      im: store.bgwheadInfo.IM ?? '',
      language: reqLanguage,
      apiBrand: 'web',
      currency:
        store.bgwheadInfo?.currency &&
        CurrencySymbol[store.bgwheadInfo?.currency?.toLocaleLowerCase()]
          ? store.bgwheadInfo?.currency
          : 'usd',
    };
    toastLang = config.headers.language;
    // if (typeof window !== 'undefined') {
    //   try {
    //     const { DX_USER } = config.data || {}
    //     let now = new Date().getTime()
    //     getDeviceId({ DX_USER }).then((token) => (DXTOKEN = token))
    //     config.headers['DX-TOKEN'] = DXTOKEN
    //     const interval = new Date().getTime() - now
    //     interval > 1000 && console.warn(`获取指纹耗时:${interval}`)
    //   } catch (error) {
    //     console.error(error)
    //   }
    // }
    return config;
  },
  error => {
    // do something with request error
    return Promise.reject(error);
  }
);

request.interceptors.response.use(
  response => {
    EventData.channel_af = response.config.url;
    return response.data;
  },
  error => {
    const errorCode = error?.status || error?.response?.status;
    if ([416, 429, 503].includes(errorCode)) {
      showToast('fail', errorStatus[errorCode][toastLang] || errorStatus[errorCode].en);
      tracker.click('b10706', {
        ...EventData,
        dataid: errorCode,
        content: errorStatus[errorCode][toastLang] || errorStatus[errorCode].en,
      });
      return Promise.reject(error);
    } else {
      // do something with response error
      const msg = error.message || 'request failed';
      showToast('fail', msg);
      tracker.click('b10706', {
        ...EventData,
        dataid: msg,
        content: msg,
      });
      return Promise.reject(error);
    }
  }
);
